import apiClient from './apiClient';

const base = '/admin/salary/danlon-payslips';
const jobPath = id => `${base}/${encodeURIComponent(id)}`;
const failure = (body, error) => Object.assign(new Error(body?.error?.message || body?.message || error.message), {
  code: body?.error?.code || body?.code, details: body?.error?.details || body?.details,
});
const request = async operation => {
  try { return (await operation()).data.data; }
  catch (error) { throw failure(error.response?.data, error); }
};
const safeDownloadName = value => Array.from(value, character => character.charCodeAt(0) < 32
  || character.charCodeAt(0) === 127 || character === '/' || character === '\\' ? '_' : character).join('');
const responseFilename = (headers, fallback) => {
  const disposition = headers?.['content-disposition'] || '';
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (encoded) {
    try { return safeDownloadName(decodeURIComponent(encoded[1])); } catch (_) { /* Use plain filename. */ }
  }
  return safeDownloadName(disposition.match(/filename="([^"]+)"/i)?.[1] || fallback);
};
const download = async (path, filename) => {
  try {
    const response = await apiClient.get(path, { responseType: 'blob', headers: { 'Cache-Control': 'no-store' } });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    try {
      link.href = url; link.download = responseFilename(response.headers, filename);
      document.body.appendChild(link); link.click();
    } finally { link.remove(); URL.revokeObjectURL(url); }
  } catch (error) {
    let body = error.response?.data;
    if (typeof body?.text === 'function') {
      try { body = JSON.parse(await body.text()); } catch (_) { /* Preserve request error. */ }
    }
    throw failure(body, error);
  }
};

const danlonPayslipService = {
  list: (year, month, signal) => request(() => apiClient.get(base, { params: { year, month }, signal })),
  // The provider's selected-month slips include paid employees and are not
  // restricted to Payroll's export selection or positive-hours population.
  start: (year, month, { requestId, mode }) => request(() => apiClient.post(base, { requestId, ...(mode ? { mode } : {}) }, { params: { year, month }, timeout: 95000 })),
  get: (id, signal) => request(() => apiClient.get(jobPath(id), { signal })),
  continue: id => request(() => apiClient.post(`${jobPath(id)}/continue`, {})),
  cancel: id => request(() => apiClient.post(`${jobPath(id)}/cancel`, {})),
  closeSession: id => request(() => apiClient.post(`/admin/salary/danlon-browser-sessions/${encodeURIComponent(id)}/end`, {})),
  frame: async (id, signal) => (await apiClient.get(`${jobPath(id)}/frame`, {
    responseType: 'blob', signal, headers: { 'Cache-Control': 'no-store' },
  })).data,
  input: async (id, input) => { await apiClient.post(`${jobPath(id)}/input`, input); },
  downloadFile: (id, document) => download(`${jobPath(id)}/files/${encodeURIComponent(document.id)}`, document.filename || 'salary-slip.pdf'),
  downloadZip: id => download(`${jobPath(id)}/download.zip`, 'VikarExperten_salary_slips.zip'),
};

export default danlonPayslipService;
